import {
  SourceSyncMetadata,
  SourceSyncMetadataBrowserbase,
  SourceSyncMetadataFileUpload,
  SourceSyncMetadataText,
  SourceSyncMetadataWebhook,
  SourceSyncMetadataWikipedia,
} from "@gx/ts-contracts/services/source/resources/source_sync_metadata/source_sync_metadata_pb";

export function isSourceSyncMetadataBrowserbase(
  metadata: SourceSyncMetadata,
): metadata is SourceSyncMetadata & {
  metadata: {
    case: "sourceSyncMetadataBrowserbase";
    value: SourceSyncMetadataBrowserbase;
  };
} {
  return metadata.metadata?.case === "sourceSyncMetadataBrowserbase";
}

export function isSourceSyncMetadataFileUpload(
  metadata: SourceSyncMetadata,
): metadata is SourceSyncMetadata & {
  metadata: {
    case: "sourceSyncMetadataFileUpload";
    value: SourceSyncMetadataFileUpload;
  };
} {
  return metadata.metadata?.case === "sourceSyncMetadataFileUpload";
}

export function isSourceSyncMetadataWikipedia(
  metadata: SourceSyncMetadata,
): metadata is SourceSyncMetadata & {
  metadata: {
    case: "sourceSyncMetadataWikipedia";
    value: SourceSyncMetadataWikipedia;
  };
} {
  return metadata.metadata?.case === "sourceSyncMetadataWikipedia";
}

export function isSourceSyncMetadataWebhook(
  metadata: SourceSyncMetadata,
): metadata is SourceSyncMetadata & {
  metadata: {
    case: "sourceSyncMetadataWebhook";
    value: SourceSyncMetadataWebhook;
  };
} {
  return metadata.metadata?.case === "sourceSyncMetadataWebhook";
}

export function isSourceSyncMetadataText(
  metadata: SourceSyncMetadata,
): metadata is SourceSyncMetadata & {
  metadata: {
    case: "sourceSyncMetadataText";
    value: SourceSyncMetadataText;
  };
} {
  return metadata.metadata?.case === "sourceSyncMetadataText";
}
